// Gift lines added by buy box v2 (assets/cloudless-buybox-v2.js) carry _cl_gift = "buybox-v2" and _cl_gift_for = the
// variant id of their pack. When that pack is no longer in the cart, its free gift lines are removed, so a gift is never
// kept on its own.
(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const EVENT = 'cloudless:buybox-gifts';
  let busy = false;

  function bundledSections() {
    const sections = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    return [...sections];
  }

  function orphans(cart) {
    const packs = new Set(cart.items.filter((item) => item.properties?._cl_buybox === 'v2').map((item) => String(item.variant_id)));
    return cart.items.filter((item) => item.properties?._cl_gift === 'buybox-v2' && !packs.has(String(item.properties?._cl_gift_for)));
  }

  async function sync(cart) {
    if (busy || !cart?.items) return;
    const lines = orphans(cart);
    if (!lines.length) return;
    busy = true;
    try {
      const body = { updates: Object.fromEntries(lines.map((item) => [item.key, 0])) };
      const sections = bundledSections();
      if (sections.length) body.sections = sections.join(',');
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || `Cart update failed (${response.status})`);
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: EVENT, cart: result } }));
    } catch (error) {
      console.error('Buy box gifts could not be removed', error);
    } finally {
      busy = false;
    }
  }

  // Pack upgrade toggle in the cart (snippets/cloudless-cart-drawer-line-item.liquid): adds the next pack with the same
  // purchase type and its gift lines, then removes the old pack and its gifts.
  async function upgradePack(wrapper, input) {
    if (wrapper.dataset.loading === 'true') return;
    wrapper.dataset.loading = 'true';
    const error = wrapper.querySelector('[data-clbx-upgrade-error]');
    if (error) error.hidden = true;
    busy = true;
    try {
      const cart = await (await fetch(`${root()}cart.js`)).json();
      const source = cart.items.find((item) => item.key === wrapper.dataset.lineKey);
      if (!source) throw new Error(wrapper.dataset.error);
      const variantId = Number(wrapper.dataset.variantId);
      const sellingPlan = Number(wrapper.dataset.sellingPlanId) || null;
      const properties = { ...source.properties };
      delete properties._cl_gifts;
      if (wrapper.dataset.flags) properties._cl_gifts = wrapper.dataset.flags;
      const main = { id: variantId, quantity: 1, properties };
      if (sellingPlan) main.selling_plan = sellingPlan;
      const gifts = (wrapper.dataset.giftLines || '').split(',').filter(Boolean).map((entry) => {
        const [id, quantity] = entry.split('*');
        return { id: Number(id), quantity: Number(quantity) || 1, properties: { _cl_gift: 'buybox-v2', _cl_gift_for: String(variantId) } };
      });
      const added = await fetch(`${root()}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [main, ...gifts] }),
      });
      if (!added.ok) throw new Error(wrapper.dataset.error);

      // Remove the old pack and the gifts that belonged to it.
      const updates = { [source.key]: 0 };
      cart.items
        .filter((item) => item.properties?._cl_gift === 'buybox-v2' && String(item.properties?._cl_gift_for) === String(source.variant_id))
        .forEach((item) => { updates[item.key] = 0; });
      const body = { updates };
      const sections = bundledSections();
      if (sections.length) body.sections = sections.join(',');
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(wrapper.dataset.error);
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }
      // Not EVENT: the Mystery Gift script and the cart listeners must see the new cart.
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cloudless:pack-upgrade', cart: result } }));
    } catch (exception) {
      input.checked = false;
      if (error) {
        error.textContent = exception.message || wrapper.dataset.error;
        error.hidden = false;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } finally {
      busy = false;
      wrapper.dataset.loading = 'false';
    }
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.clcd-pack-upgrade__input');
    const wrapper = input?.closest('[data-clbx-upgrade]');
    if (wrapper && input.checked) upgradePack(wrapper, input);
  });

  document.addEventListener('cart:change', (event) => {
    if (event.detail?.baseEvent === EVENT) return;
    const cart = event.detail?.cart;
    if (cart?.items) sync(cart);
  });
  fetch(`${root()}cart.js`).then((response) => response.json()).then(sync).catch((error) => console.error(error));
})();
